import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .devices-list {
    position: relative;
  }
  .productsContainer {
    display: flex;
    flex-direction: column; 
  }

  :global(.floating-alert-button) {
      margin-top:1rem;
  }

  .featured-carousel{
    margin-top:1.5rem;
  }

  .productsContainerServer {
    opacity: 0;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .productsContainer .filtersContainer {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    animation: fadeIn 0.5s ease-in-out;
    //width: 100%;
  }

  :global(.devicesHeader) {
    display: flex;
    justify-content: space-between;
  }

  :global(.filtersHeader .buttonx) {
    padding: 0px;
  }

  :global(.devicesOrder span) {
    margin-right: 5px;
    margin-left: 5px;
  }
  .searcher-container {
    width: 100%;
  }

  .devicesContainer {
    animation: fadeIn 0.5s ease-in-out;
    min-height: 400px;
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 12px;
  }

  :global(.devicesOrder) {
    display: flex;
  }

  :global(.deviceOrderOption) {
    cursor: pointer;
  }

  :global(.deviceOrderOption:focus-visible) {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 2px;
  }

  .devicesCounter {
    display: flex;
  }

  .devicesMobile {
    display: none;
  }

  .devicesMobileHeaderContent {
    display: flex;
    align-items: center;
    flex: 1;
    gap: 2rem;
    justify-content: space-between;
    width: 100%;
    .badgeFiltros {
      flex-shrink: 0;
    }
  }
  :global(.devicesDesktop) {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  :global(.devicesCounter h2) {
    margin-right: 5px;
  }

  .badgeFiltros {
    font: inherit;
    background: transparent;
    min-width: 125px;
    cursor: pointer;
    padding: 5px 15px;
    -webkit-letter-spacing: 0px;
    -moz-letter-spacing: 0px;
    -ms-letter-spacing: 0px;
    letter-spacing: 0px;
    display: flex;
    color: black;
    border: 2px solid #dddddd;
    border-radius: 4px;
    opacity: 1;
    align-items: center;
    justify-content: space-between;
    font-family: Regular;
    gap: 5px;
  }

  :global(.badgeFiltros .svg-layout-size) {
    margin-left: 8px;
  }

  .devicesMobileHeaderOffers {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    gap: 0.8rem;
  }

  .devicesMap {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    grid-gap: 24px;
    align-content: start;
    align-items: stretch;
  }
  //TODO: REMOVE Se hace negando, por si no fuera el navegador compatible se minimice el impacto en los estilos, y no se corten textos
  .devicesMap:not(:has(.device-card--container--image-stamp-container--stamp)){
    //Al no haber sellos, reduzco el tamaño del contenedor de imagen y sello
    :global(.device-card--container--image-stamp-container) {
        //height: 11.5rem;
    }

  .badgeFiltros:focus-visible {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
    outline-offset: 3px;
  }
  }
  //TODO: REMOVE
  .devicesMap:has(.device-card--container--image-stamp-container--stamp){
    //Al haber sellos, se decrece el ratio para que no parezca muy grande
    :global(.device-card--container--image-stamp-container--image-box) {
        //height: 95%;
    }
  }

  .filtersHeader {
    display: none;
    height: 48px;
    margin-bottom: 5px;
    align-items: center;
    justify-content: space-between;
  }

  .filters-section {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
      .filters-desktop {
        display: none;
      }
  }

  :global(.devicesMap .device-card) {
    padding: 0px !important;
  }

  :global(.device-card:empty) {
    display: none;
  }

  :global(.deviceMapMin .device-card) {
    min-width: 230px !important;
    max-width: 230px;
  }

  :global(.card.layout-product) {
    position: relative;
    padding: 1.5rem 1rem;
    flex: 1;
  }

  :global(.card.layout-product .card-container) {
    flex-direction: row;
    flex: 1;
  }

  :global(.device-card-height .card-container) {
    gap: 0;
  }

  :global(.card.layout-product .card-container--info) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
    height: 100%;
  }

  :global(.card-backgroundImg-1 .image) {
    border-radius: 16px;
  }

  :global(.nextLinkOverBox) {
    z-index: 10;
  }

  @media (max-width: 1920px) {
    .devicesMap {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }
  @media (min-width: 969px) {

    .deviceMapMin {
      display: flex;
    }
  }

  @media (max-width: 1067px) {
    .devicesMobileHeaderContent {
      gap: 0.5rem;
    }
    :global(.deviceMapMin) {
      display: grid;
    }
    :global(.deviceMapMin .device-card) {
      min-width: auto !important;
    }

    .devicesDesktop {
      display: none !important;
    }

    .devicesMobile {
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
    }
    .devicesHeader {
      display: block;
    }
  }

  @media (min-width: 768px) and (max-width: 1067px) {
    .devicesMobile {
      display: flex;
      flex-direction: row;
    }
    .filters-section {
      flex-direction: row;
    }

    .devicesMobileHeaderContent {
      align-items: center;
      justify-content: end;
    }

    .searcher-a {
      transition: all 0.3s;
    }

    .blurred-search {
      transition: all 0.3s;
      width: 40px;
      display: block;
    }

    :global(.blurred-search input) {
      border: none !important;
    }

    .focused-search {
      width: 100%;
      display: flex !important;
      flex-direction: column;
    }

    .focused-search {
      transition: all 0.3s;
      display: block;
    }
  }

  @media (max-width: 767px) {
    .searcher {
      margin: 0px;
    }

    .devicesMap {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
  }

  @media (max-width: 480px) {
    .devicesMap {
      grid-gap: 12px;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    }

    :global(.devicesMap .card-container .crazy-label) {
      left: 15px;
    }

    :global(.devicesMap .card.layout-device) {
      padding: 7px;
    }

    :global(.devicesMap .cardContainer) {
      position: relative;
    }
  }

  @media (max-width: 300px) {
    :global(.devicesMap .card-container .device-card--container) {
      width: 100%;
    }
    :global(.devicesMap .card-container .device-card--container--image-box) {
      margin: 0.75rem auto;
    }
  }
  @media screen and (min-width: 1068px) {
    .devicesMap {
      grid-gap: 12px;
    }

    .devicesContainer {
      margin-top: 24px;
    }
    .filters-section {
      .filters-desktop {
        display: flex;
        flex-direction: column;
      }
    }
    .productsContainer {
      flex-direction: row; 
    }
    .productsContainer .filtersContainer {
      max-width: 220px;
      padding: 0px;
      padding-right: 20px;
    }
    .filtersHeader {
      display: flex;
    }
  }

  @media screen and (max-width: 1067px) {
    .devicesContainer {
      margin-top: 12px;
    }
    .productsContainer .filtersContainer {
      //display: none;
    }

    .productsContainer .devicesOrder {
      display: none;
    }
  }

  @media screen and (max-width: 767px) {

    :global(.device) {
      width: 100%;
    }

    .devicesMobileHeaderOffers {
      flex-direction: column;
      align-items: start;
    }
  }
`;
